import {
  CallPermission,
  CallPermissionNames,
  CallPermissionPediod,
} from '@src/types/calls';
import { useMemo } from 'react';

export type CallPermissionFlags = {
  isSendCallTemplateExceeded: boolean;
  isStartCallExceeded: boolean;
  isSendCallTemplateExceeded24h: boolean;
  isSendCallTemplateExceeded7d: boolean;
  hasAnyPermissionExceeded: boolean;
  isStartCallAllowed: boolean;
};

export const callPermissionFlags = (
  permissions: CallPermission[] = []
): CallPermissionFlags => {
  const permissionExceeded = permissions?.find(
    permission => !permission.allowed
  );

  const isStartCallAllowed = permissions?.some(
    permission =>
      permission.allowed && permission.name === CallPermissionNames.START_CALL
  );

  const isStartCallExceeded = !permissions.some(
    permission =>
      permission.name === CallPermissionNames.SEND_CALL_PERMISSION_REQUEST
  );

  const isSendCallTemplateExceeded =
    permissionExceeded?.name ===
    CallPermissionNames.SEND_CALL_PERMISSION_REQUEST;

  const isSendCallTemplateExceeded24h =
    isSendCallTemplateExceeded &&
    permissionExceeded?.usage.period === CallPermissionPediod.PT24H;

  const isSendCallTemplateExceeded7d =
    isSendCallTemplateExceeded &&
    permissionExceeded?.usage.period === CallPermissionPediod.P7D;

  const hasAnyPermissionExceeded = !!permissionExceeded;

  return {
    isSendCallTemplateExceeded,
    isStartCallExceeded,
    isSendCallTemplateExceeded24h,
    isSendCallTemplateExceeded7d,
    hasAnyPermissionExceeded,
    isStartCallAllowed,
  };
};

const useCallPermissionFlags = (
  permissions: CallPermission[] = []
): CallPermissionFlags =>
  useMemo(() => callPermissionFlags(permissions), [permissions]);

export default useCallPermissionFlags;
